module.exports = "<a class=\"link\" (click)=\"showDetail()\">\n  {{user != null ? user.username : \"\"}}\n</a>\n"